import template from './floors-count-house.jade';
import validation from '../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular
  .module('cian.addForm.commonFloorsCountHouse', [])
  .directive('cianAfCommonFloorsCountHouse', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService, store) {
      'ngInject';
      this.isMobile = deviceService.isMobile;
      this.floorsMin = 1;
      this.floorsMax = 999;

      this.validation = validation(this.form, 'floorsCountHouse', {
        parse: 'Введите число',
        min: 'Количество этажей должено быть больше 0',
        max: 'Допустимо не более 3 символов',
      });

      let trackedValue;

      this.handleBlur = () => {
        const value = this.ad.building.floorsCount;

        if (value && value !== trackedValue) {
          const state = store.getState();
          const category = selectAnalyticsOfferStatus(state);

          trackRequiredFieldFill(category, 'number_of_floors');
          trackedValue = value;
        }
      };
    },
    controllerAs: 'floorsCountHouse',
    template,
  })).name;
